import ImagePlaceholder from "@/components/base/ImagePlaceholder";

export default function Calibrage() {
  const checks = [
    "Réglage de la tension du ressort d'équilibrage",
    "Vérification de l'enroulement dans le coffre",
    "Alignement des lames dans les glissières latérales",
    "Contrôle des butées de fin de course",
    "Test de la manœuvre manuelle ou motorisée",
    "Vérification de l'étanchéité et de l'absence de jeu",
  ];

  return (
    <section className="bg-white py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div className="relative rounded-xl overflow-hidden border border-[#E2E8F0]">
            <ImagePlaceholder src="https://readdy.ai/api/search-image?query=Professional%20technician%20calibrating%20and%20aligning%20a%20white%20roller%20shutter%20tablier%20with%20precision%20tools%20in%20a%20clean%20workshop%20environment%20bright%20lighting%20warm%20neutral%20tones%20professional%20service%20photography&width=700&height=520&seq=tab-calibr&orientation=landscape" alt="Calibrage et alignement du tablier de volet roulant" className="w-full h-[340px] md:h-[420px]" loading="lazy" />
          </div>

          <div>
            <h2 className="text-[#143A66] text-2xl md:text-3xl font-extrabold mb-5">
              Calibrage après remplacement
            </h2>
            <p className="text-[#2F4A63] text-base leading-relaxed mb-5">
              Le calibrage est l'étape cruciale qui garantit le bon fonctionnement du nouveau tablier. Après la pose, le tablier doit s'enrouler parfaitement dans le coffre sans chevaucher les lames ni frotter contre les parois. Le réglage de la tension du ressort d'équilibrage est essentiel : une tension trop faible empêche le tablier de monter, une tension trop forte le fait remonter trop vite. Nos techniciens ajustent ce paramètre avec précision pour chaque volet.
            </p>
            <p className="text-[#2F4A63] text-base leading-relaxed mb-6">
              Nous vérifions aussi l'alignement des lames dans les glissières latérales. Un mauvais alignement provoque des frottements, des bruits et une usure prématurée des lames. Nous contrôlons les butées de fin de course pour que le tablier s'arrête exactement à la bonne hauteur, sans forcer sur le moteur ni sur la manœuvre manuelle. Ce calibrage minutieux assure une durée de vie maximale au nouveau tablier.
            </p>

            <ul className="space-y-3 mb-8">
              {checks.map((check) => (
                <li key={check} className="flex items-center gap-3">
                  <span className="w-6 h-6 flex items-center justify-center rounded-full bg-[#00B3A4]/10 shrink-0">
                    <i className="ri-check-line text-[#00B3A4] text-sm"></i>
                  </span>
                  <span className="text-[#2F4A63] text-base">{check}</span>
                </li>
              ))}
            </ul>

            <a
              href="tel:0374473240"
              className="flex items-center gap-2 bg-[#00B3A4] text-white px-6 py-4 rounded-full font-semibold text-base hover:bg-[#00B3A4]/90 transition-colors whitespace-nowrap mx-auto"
            >
              <i className="ri-phone-line text-lg"></i>
              Appeler le 03 74 47 32 40
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}